import { render, staticRenderFns } from "./DashboardOrdini.vue?vue&type=template&id=201c93ba&scoped=true&"
import script from "./DashboardOrdini.vue?vue&type=script&lang=js&"
export * from "./DashboardOrdini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c93ba",
  null
  
)

export default component.exports